import { InfoAreaContainer as InfoAreaContainerBase } from './styled-components';
import styled from 'styled-components';

export const InfoAreaContainer = styled(InfoAreaContainerBase)`
  margin-top: 32px;
  padding: 21px; 26px; 16px; 26px;
`;
